import React, { useContext, useState } from "react";
import LayoutDashboard from "../../Components/Layout/LayoutDashboard";
import {
  Button,
  Divider,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import { useForm } from "react-hook-form";
import SelectClient from "./SelectOptionsAdd/SelectClient";
import SelectState from "./SelectOptionsAdd/SelectState";
import SelectMunicipality from "./SelectOptionsAdd/SelectMunicipality";
import SelectCfdi from "./SelectOptionsAdd/SelectCfdi";
import BillingAddressContext from "../../Reducers/BillingAddress/BillingAddressContext";
import SelectTaxtSystem from "./SelectOptionsAdd/SelectTaxtSystem";

const useStyles = makeStyles((theme) => ({
  fabGreen: {
    color: theme.palette.common.white,
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[600],
    },
  },
  container: {
    padding: theme.spacing(4, 11, 4, 2),
  },
  titleBar: {
    background: "linear-gradient(50deg, #3f51b5 33%, indigo 100%)",
    color: "white",
    borderRadius: 15,
    margin: "100px 25px 20px",
    padding: "10px 20px",
  },
}));

const AddBillingAddresses = () => {
  const { AddBillingAddresses } = useContext(BillingAddressContext);
  const classes = useStyles();
  const id_branch_office = 1;

  const [client, saveClient] = useState(null);
  const detectarCambiosClient = (value) => {
    saveClient(value.value);
  };

  const [Cfdi, saveCfdi] = useState(null);
  const detectarCambiosCfdi = (value) => {
    saveCfdi(value.value);
  };

  const [state, saveState] = useState(null);
  const detectarCambiosState = (value) => {
    saveState(value.value);
  };

  const [municipality, saveMunicipality] = useState(null);
  const detectarCambiosMunicipality = (value) => {
    saveMunicipality(value.value);
  };

  const [TaxtSystem, saveTaxtSystem] = useState(null);
  const detectarCambiosTaxtSystem = (value) => {
    saveTaxtSystem(value.value);
  };

  const { register, handleSubmit, errors } = useForm();

  const onSubmit = async (data, e) => {
    data.name = data.name;
    data.rfc = data.rfc;
    data.country = data.country;
    data.postal_code = data.postal_code;
    data.address = data.address;
    data.no_ext = data.no_ext;
    data.client_id = client;
    data.cfdi = Cfdi;
    data.state_id = state;
    data.municipality_id = municipality;
    data.taxt_system = TaxtSystem;
    AddBillingAddresses(data);
  };

  return (
    <LayoutDashboard>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Grid container>
          <Grid item xs={12} className={classes.titleBar}>
            <Typography variant="h4">Crear Direccion de Facturación</Typography>
          </Grid>
          <Grid
            container
            spacing={4}
            style={{ marginLeft: 20, marginRight: 20 }}
          >
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Divider />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="name"
                label="Nombre Completo:"
                name="name"
                autoComplete="name"
                autoFocus
                error={!!errors.name}
                inputRef={register({
                  required: {
                    value: true,
                    message: "El Nombre es requerido",
                  },
                  minLength: {
                    value: 1,
                    message: "Minimo 1 caracter",
                  },
                  maxLength: {
                    value: 100,
                    message: "Maximo 100 caracteres",
                  },
                })}
              />
              <p>{errors?.name?.message}</p>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="rfc"
                label="RFC:"
                name="rfc"
                autoComplete="rfc"
                autoFocus
                type="text"
                error={!!errors.rfc}
                inputRef={register({
                  required: {
                    value: true,
                    message: "El RFC es requerido",
                  },
                  minLength: {
                    value: 13,
                    message: "Mínimo 13 carácteres",
                  },
                  maxLength: {
                    value: 13,
                    message: "Máximo 13 caracteres",
                  },
                })}
              />
              <p>{errors?.rfc?.message}</p>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="country"
                label="País:"
                name="country"
                autoComplete="country"
                autoFocus
                type="text"
                error={!!errors.country}
                inputRef={register({
                  required: {
                    value: true,
                    message: "El Pais es requerido",
                  },
                  minLength: {
                    value: 1,
                    message: "Mínimo 1 carácter",
                  },
                  maxLength: {
                    value: 50,
                    message: "Máximo 50 caracteres",
                  },
                })}
              />
              <p>{errors?.country?.message}</p>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="postal_code"
                label="Codigo Postal:"
                name="postal_code"
                autoComplete="postal_code"
                autoFocus
                type="number"
                error={!!errors.postal_code}
                inputRef={register({
                  required: {
                    value: true,
                    message: "El Codio Postal es requerido",
                  },
                  minLength: {
                    value: 5,
                    message: "Mínimo 5 carácteres",
                  },
                  maxLength: {
                    value: 5,
                    message: "Máximo 5 caracteres",
                  },
                })}
              />
              <p>{errors?.postal_code?.message}</p>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="address"
                label="Calle:"
                name="address"
                autoComplete="address"
                autoFocus
                type="text"
                error={!!errors.address}
                inputRef={register({
                  required: {
                    value: true,
                    message: "La Calle es requerida",
                  },
                  minLength: {
                    value: 5,
                    message: "Mínimo 5 carácteres",
                  },
                  maxLength: {
                    value: 100,
                    message: "Máximo 100 caracteres",
                  },
                })}
              />
              <p>{errors?.address?.message}</p>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="no_ext"
                label="No_Ext:"
                name="no_ext"
                autoComplete="no_ext"
                autoFocus
                type="number"
                error={!!errors.no_ext}
                inputRef={register({
                  required: {
                    value: true,
                    message: "El No_Ext es requerido",
                  },
                  minLength: {
                    value: 1,
                    message: "Mínimo 1 carácter",
                  },
                  maxLength: {
                    value: 10,
                    message: "Máximo 10 caracteres",
                  },
                })}
              />
              <p>{errors?.no_ext?.message}</p>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <SelectClient
                detectarCambiosClient={detectarCambiosClient}
                id_branch_office={id_branch_office}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <SelectCfdi detectarCambiosCfdi={detectarCambiosCfdi} />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <SelectTaxtSystem
                detectarCambiosTaxtSystem={detectarCambiosTaxtSystem}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <SelectState detectarCambiosState={detectarCambiosState} />
            </Grid>
            {state !== null && (
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <SelectMunicipality
                  detectarCambiosMunicipality={detectarCambiosMunicipality}
                  state_id={state}
                />
              </Grid>
            )}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Button
                variant="outlined"
                type="submit"
                size="large"
                fullWidth
                style={{
                  background: "#E0BCE7",
                  color: "black",
                  "&:hover": { background: "#E0BCE7", color: "black" },
                }}
              >
                Crear
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </LayoutDashboard>
  );
};

export default AddBillingAddresses;
